// extracted by mini-css-extract-plugin
export default {"warranty-and-policy-buttons__hr":"warranty-and-policy-buttons__hr_EvDrlFPY"};